import * as React from 'react';
import {
  MenuItem,
  Tooltip,
  List,
  TooltipProps,
  styled,
  tooltipClasses,
  ListItemIcon,
} from '@mui/material';

export type MenuPopoverProps = {
  children: any;
  close: Function;
  menuItems?: { icon?: React.ReactNode; label: string; onClick: Function }[];
};

export const MenuPopover = ({
  children,
  close,
  menuItems,
}: MenuPopoverProps) => {
  return (
    <StyledMenuTooltip
      placement="left"
      title={
        <List
          sx={{
            width: 'fit-content',
            backgroundColor: 'white',
            borderRadius: '4px',
            border: theme => `2px solid ${theme.palette.secondary.main}`,
          }}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
          }}
          disablePadding
        >
          {menuItems &&
            menuItems.map(({ icon, label, onClick }, index) => (
              <MenuItem
                dense
                divider
                id={`List-${label}`}
                key={index}
                onClick={() => {
                  close();
                  onClick();
                }}
                sx={{ minWidth: 120, minHeight: 'auto' }}
              >
                {icon && (
                  <ListItemIcon id={`List-${label}`}>
                    <div id={`List-${label}`}>{icon}</div>
                  </ListItemIcon>
                )}
                {label}
              </MenuItem>
            ))}
        </List>
      }
    >
      {children}
    </StyledMenuTooltip>
  );
};

export const StyledMenuTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: '50%',
    // whiteSpace: 'pre-line',
    backgroundColor: 'transparent',
    // border: `1px solid ${theme.palette.secondary}`,
    color: 'rgba(0, 0, 0, 0.87)',
    // boxShadow: theme.shadows[2],
    // boxShadow: '0px 6px 6px -3px rgb(118, 176, 65,0.8), 0px 10px 14px 1px rgb(118, 176, 65, 0.5), 0px 4px 18px 3px rgb(118, 176, 65, 0.5)',
    fontSize: 8,
  },
}));
